// extracted by mini-css-extract-plugin
export default {"content":"NoteExpertGeneralPage_content__z0I6v"};